"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { class: "patient-card" };
var _hoisted_2 = { class: "card-header" };
var _hoisted_3 = { class: "header-info" };
var _hoisted_4 = { class: "patient-name" };
var _hoisted_5 = { class: "mrn" };
var _hoisted_6 = { class: "menu-container" };
var _hoisted_7 = {
    key: 1,
    class: "menu-dropdown"
};
var _hoisted_8 = { class: "card-body" };
var _hoisted_9 = { class: "info-row" };
var _hoisted_10 = { class: "info-text" };
var _hoisted_11 = ["href"];
var _hoisted_12 = { class: "info-row" };
var _hoisted_13 = { class: "info-text email-text" };
var _hoisted_14 = { class: "info-row address-row" };
var _hoisted_15 = { class: "info-text" };
var _hoisted_16 = { class: "info-row address-row" };
var _hoisted_17 = {
    key: 0,
    class: "glyphicon bi-arrow-repeat spin-icon",
    style: { "font-size": "17px" }
};
var _hoisted_18 = { key: 1 };
var _hoisted_19 = { class: "info-row address-row" };
var _hoisted_20 = { class: "info-text" };
var _hoisted_21 = { class: "info-row address-row" };
var _hoisted_22 = { class: "info-text" };
var _hoisted_23 = {
    key: 0,
    class: "info-row tags-row"
};
var _hoisted_24 = { class: "bi bi-check" };
var _hoisted_25 = {
    key: 1,
    class: "info-row tags-row"
};
var _hoisted_26 = { class: "bi bi-checked" };
var _hoisted_27 = { class: "info-row tags-row" };
var _hoisted_28 = { class: "bi bi-checked" };
var _hoisted_29 = { class: "info-row tags-row" };
var _hoisted_30 = { class: "bi bi-checked" };
var _hoisted_31 = { class: "info-row tags-row" };
var _hoisted_32 = { class: "bi bi-money" };
var _hoisted_33 = { class: "info-row" };
var _hoisted_34 = { class: "bi bi-checked" };
var _hoisted_35 = {
    key: 2,
    class: "info-row tags-row"
};
var _hoisted_36 = ["href"];
var _hoisted_37 = {
    key: 1,
    class: "doc-name"
};
var _hoisted_38 = {
    key: 3,
    class: "info-row"
};
var _hoisted_39 = ["href"];
var _hoisted_40 = {
    key: 1,
    class: "doc-name"
};
var _hoisted_41 = { class: "card-footer" };
var vue_3 = require("vue");
var vuex_1 = require("vuex");
var fileUrl_1 = require("@/utils/fileUrl");
var privilegesApi_1 = require("@/api/privilegesApi");
var privileges_1 = require("@/stores/privileges");
var privileges_2 = require("@/constants/privileges");
var nursysApi_1 = require("@/api/nursysApi");
exports.default = (0, vue_1.defineComponent)({
    __name: 'NurseCard',
    props: {
        nurse: {}
    },
    emits: ["edit", "email", "sms", "call"],
    setup: function (__props, _a) {
        var __emit = _a.emit;
        var props = __props;
        var vuexStore = (0, vuex_1.useStore)();
        var privilegesStore = (0, privileges_1.usePrivilegesStore)();
        // Viewing your OWN license/insurance/misc is never gated - only viewing
        // another caregiver's documents (e.g. an office manager auditing/uploading
        // on their behalf) requires the view_caregiver_documents privilege.
        var isOwnRecord = (0, vue_3.computed)(function () {
            var unique_ID = (0, privilegesApi_1.resolveKeyonPrivilegeIdentity)(vuexStore.getters['login/getAllData']).unique_ID;
            return !!unique_ID && String(unique_ID) === String(props.nurse.providerid || '');
        });
        var canViewDocs = (0, vue_3.computed)(function () { return isOwnRecord.value || privilegesStore.effectiveGranted(privileges_2.PRIVILEGES.VIEW_CAREGIVER_DOCUMENTS); });
        var emit = __emit;
        var todaydt = new Date();
        var showMenu = (0, vue_3.ref)(false);
        var unencumbered = (0, vue_3.ref)('Unencumbered');
        var isVerifying = (0, vue_3.ref)(false);
        /*const initials = computed(() => {
          return `${props.patient.firstName[0]}${props.patient.lastName[0]}`.toUpperCase()
        })*/
        // A card shows its document rows only when keyon returned a file uid for
        // at least one of them.
        var doesHaveDocs = (0, vue_3.computed)(function () {
            return (0, fileUrl_1.isFileUid)(props.nurse.insuranceFileUid) || (0, fileUrl_1.isFileUid)(props.nurse.licenseFileUid);
        });
        // Computed property for initials
        var initials = (0, vue_3.computed)(function () {
            var firstInitial = props.nurse.firstName ? props.nurse.firstName[0] : '';
            var lastInitial = props.nurse.lastName ? props.nurse.lastName[0] : '';
            return "".concat(firstInitial).concat(lastInitial).toUpperCase();
        });
        function formatDateToYYYYMMDD(d) {
            return (d.getFullYear() +
                '-' +
                String(d.getMonth() + 1).padStart(2, '0') +
                '-' +
                String(d.getDate()).padStart(2, '0'));
        }
        function handleEditClick() {
            showMenu.value = false;
            emit('edit', props.nurse);
        }
        function VerifyNurse(nurse) {
            return __awaiter(this, void 0, void 0, function () {
                var licensenumber, verdict, matching;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            //start of verification process 
                            isVerifying.value = true;
                            licensenumber = nurse.licenseNumber;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 3, 4]);
                            return [4 /*yield*/, (0, nursysApi_1.lookupNurse)({
                                    rnlicense: licensenumber,
                                    jurisdiction: nurse.address.state,
                                    ltype: nurse.licenseType,
                                    accountnumber: nurse.accountnumber,
                                })];
                        case 2:
                            verdict = _a.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            isVerifying.value = false;
                            return [7 /*endfinally*/];
                        case 4:
                            if (verdict.kind === nursysApi_1.UNAVAILABLE) {
                                // A request keyon refused outright (a lapsed session is a 401 from its
                                // Nursys gate) carries keyon's own sentence; say that rather than
                                // blaming the service.
                                alert(verdict.refusal || "We could not reach the license verification service just now. Please try again in a few minutes.");
                                return [2 /*return*/];
                            }
                            if (verdict.kind === nursysApi_1.NOT_ENROLLED || verdict.kind === nursysApi_1.REJECTED) {
                                alert(verdict.message || ("No result found for license number " + licensenumber));
                                return [2 /*return*/];
                            }
                            // Only a real answer advances the date on the card.
                            nurse.licenseLastChecked = formatDateToYYYYMMDD(todaydt);
                            matching = verdict.licences.filter(function (l) { return l && l.LicenseType == nurse.licenseType; });
                            if (!matching.length) {
                                alert("No " + nurse.licenseType + " license found for " + licensenumber + ".");
                                return [2 /*return*/];
                            }
                            matching.forEach(function (licence) {
                                if ((0, nursysApi_1.isLicenceInGoodStanding)(licence)) {
                                    alert("License Active, no action needed.");
                                }
                                else if ((0, nursysApi_1.isLicenceReinstated)(licence)) {
                                    alert("License Reinstated");
                                }
                                else {
                                    alert("License Not Active, please take action as needed.");
                                }
                            });
                            return [2 /*return*/];
                    }
                });
            });
        }
        return function (_ctx, _cache) {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", {
                        class: "avatar",
                        style: (0, vue_2.normalizeStyle)({ background: _ctx.nurse.avatarColor })
                    }, (0, vue_2.toDisplayString)(initials.value), 5),
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createElementVNode)("h3", _hoisted_4, (0, vue_2.toDisplayString)(_ctx.nurse.lastName) + ", " + (0, vue_2.toDisplayString)(_ctx.nurse.firstName), 1),
                        (0, vue_2.createElementVNode)("span", _hoisted_5, (0, vue_2.toDisplayString)(_ctx.nurse.arn), 1)
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_6, [
                        (0, vue_2.createElementVNode)("button", {
                            type: "button",
                            class: "menu-btn",
                            onClick: _cache[0] || (_cache[0] = function ($event) { return (showMenu.value = !showMenu.value); })
                        }, __spreadArray([], (_cache[6] || (_cache[6] = [
                            (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-option-vertical bi-three-dots-vertical" }, null, -1)
                        ])), true)),
                        (showMenu.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                key: 0,
                                class: "menu-backdrop",
                                onClick: _cache[1] || (_cache[1] = function ($event) { return (showMenu.value = false); })
                            }))
                            : (0, vue_2.createCommentVNode)("", true),
                        (showMenu.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_7, [
                                (0, vue_2.createElementVNode)("button", {
                                    type: "button",
                                    class: "menu-item",
                                    onClick: handleEditClick
                                }, __spreadArray([], (_cache[7] || (_cache[7] = [
                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-pencil bi-pencil" }, null, -1),
                                    (0, vue_2.createTextVNode)(" Edit Demographics ", -1)
                                ])), true))
                            ]))
                            : (0, vue_2.createCommentVNode)("", true)
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_8, [
                    (0, vue_2.createElementVNode)("div", _hoisted_9, [
                        _cache[8] || (_cache[8] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-phone" }, "Phone", -1)),
                        (0, vue_2.createElementVNode)("span", _hoisted_10, [
                            (0, vue_2.createElementVNode)("a", {
                                href: 'tel:' + _ctx.nurse.phone + '',
                                title: "Nurse Phone"
                            }, (0, vue_2.toDisplayString)(_ctx.nurse.phone), 9, _hoisted_11)
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_12, [
                        _cache[9] || (_cache[9] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-envelope" }, "Email:", -1)),
                        (0, vue_2.createElementVNode)("span", _hoisted_13, (0, vue_2.toDisplayString)(_ctx.nurse.email), 1)
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_14, [
                        _cache[11] || (_cache[11] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-map-marker" }, "Address:", -1)),
                        (0, vue_2.createElementVNode)("span", _hoisted_15, [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(_ctx.nurse.address.street), 1),
                            _cache[10] || (_cache[10] = (0, vue_2.createElementVNode)("br", null, null, -1)),
                            (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(_ctx.nurse.address.city) + ", " + (0, vue_2.toDisplayString)(_ctx.nurse.address.state) + " " + (0, vue_2.toDisplayString)(_ctx.nurse.address.zip), 1)
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_16, [
                        _cache[12] || (_cache[12] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-certificate" }, "License Number:", -1)),
                        (0, vue_2.createElementVNode)("span", {
                            class: "info-text email-text verify-nurse",
                            onClick: _cache[2] || (_cache[2] = function ($event) { return (VerifyNurse(_ctx.nurse)); })
                        }, (0, vue_2.toDisplayString)(_ctx.nurse.licenseNumber), 1),
                        (isVerifying.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_17))
                            : (0, vue_2.createCommentVNode)("", true),
                        (isVerifying.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_18, "Verifying..."))
                            : (0, vue_2.createCommentVNode)("", true)
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_19, [
                        _cache[14] || (_cache[14] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-certificate" }, "License Type:", -1)),
                        (0, vue_2.createElementVNode)("span", _hoisted_20, [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(_ctx.nurse.licenseType), 1),
                            _cache[13] || (_cache[13] = (0, vue_2.createElementVNode)("br", null, null, -1))
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_21, [
                        _cache[16] || (_cache[16] = (0, vue_2.createElementVNode)("span", { class: "bi bi-status" }, "Status:", -1)),
                        (0, vue_2.createElementVNode)("span", _hoisted_22, [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(_ctx.nurse.activeStatus), 1),
                            _cache[15] || (_cache[15] = (0, vue_2.createElementVNode)("br", null, null, -1))
                        ])
                    ]),
                    (_ctx.nurse.licenseLastChecked != '')
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_23, [
                            _cache[17] || (_cache[17] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-certificate" }, "Last License Check:", -1)),
                            (0, vue_2.createElementVNode)("span", _hoisted_24, (0, vue_2.toDisplayString)(_ctx.nurse.licenseLastChecked), 1)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (_ctx.nurse.licenseLastChecked != '')
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_25, [
                            _cache[18] || (_cache[18] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-certificate" }, "License Status:", -1)),
                            (0, vue_2.createElementVNode)("span", _hoisted_26, (0, vue_2.toDisplayString)(unencumbered.value), 1)
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (0, vue_2.createElementVNode)("div", _hoisted_27, [
                        _cache[19] || (_cache[19] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-certificate" }, "Insurance Company:", -1)),
                        (0, vue_2.createElementVNode)("span", _hoisted_28, (0, vue_2.toDisplayString)(_ctx.nurse.insuranceCompany), 1)
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_29, [
                        _cache[20] || (_cache[20] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-certificate" }, "Expiration Date:", -1)),
                        (0, vue_2.createElementVNode)("span", _hoisted_30, (0, vue_2.toDisplayString)(_ctx.nurse.licenseExpDt), 1)
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_31, [
                        _cache[21] || (_cache[21] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-warining" }, "Per Incedent:", -1)),
                        (0, vue_2.createElementVNode)("span", _hoisted_32, (0, vue_2.toDisplayString)(_ctx.nurse.perIncidentAmount), 1)
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_33, [
                        _cache[22] || (_cache[22] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-dollar" }, "Annual Aggregate Amount:", -1)),
                        (0, vue_2.createElementVNode)("span", _hoisted_34, (0, vue_2.toDisplayString)(_ctx.nurse.annualAmount), 1)
                    ]),
                    (doesHaveDocs.value && canViewDocs.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_35, [
                            _cache[23] || (_cache[23] = (0, vue_2.createElementVNode)("span", {
                                class: "bi bi-files",
                                style: { "font-size": "15px" }
                            }, null, -1)),
                            _cache[24] || (_cache[24] = (0, vue_2.createElementVNode)("span", { class: "info-text" }, "Insurance Document", -1)),
                            ((0, vue_2.unref)(fileUrl_1.isFileUid)(_ctx.nurse.insuranceFileUid))
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("a", {
                                    key: 0,
                                    href: (0, vue_2.unref)(fileUrl_1.keyonFileUrl)(_ctx.nurse.insuranceFileUid),
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    class: "doc-name",
                                    title: "Insurance document"
                                }, (0, vue_2.toDisplayString)(_ctx.nurse.insuranceDocName), 9, _hoisted_36))
                                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_37, "Document unavailable")),
                            _cache[25] || (_cache[25] = (0, vue_2.createElementVNode)("br", null, null, -1))
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (doesHaveDocs.value && canViewDocs.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_38, [
                            _cache[26] || (_cache[26] = (0, vue_2.createElementVNode)("span", {
                                class: "bi bi-files",
                                style: { "font-size": "15px" }
                            }, null, -1)),
                            _cache[27] || (_cache[27] = (0, vue_2.createElementVNode)("span", { class: "info-text" }, "License Document", -1)),
                            _cache[28] || (_cache[28] = (0, vue_2.createElementVNode)("br", null, null, -1)),
                            ((0, vue_2.unref)(fileUrl_1.isFileUid)(_ctx.nurse.licenseFileUid))
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("a", {
                                    key: 0,
                                    href: (0, vue_2.unref)(fileUrl_1.keyonFileUrl)(_ctx.nurse.licenseFileUid),
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    class: "doc-name",
                                    title: "License document"
                                }, (0, vue_2.toDisplayString)(_ctx.nurse.licenseDocName), 9, _hoisted_39))
                                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_40, "Document unavailable"))
                        ]))
                        : (0, vue_2.createCommentVNode)("", true)
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_41, [
                    (0, vue_2.createElementVNode)("button", {
                        type: "button",
                        class: "quick-action email-action",
                        onClick: _cache[3] || (_cache[3] = function ($event) { return (_ctx.$emit('email', _ctx.nurse)); })
                    }, __spreadArray([], (_cache[29] || (_cache[29] = [
                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-envelope" }, null, -1),
                        (0, vue_2.createTextVNode)(" Email ", -1)
                    ])), true)),
                    (0, vue_2.createElementVNode)("button", {
                        type: "button",
                        class: "quick-action sms-action",
                        onClick: _cache[4] || (_cache[4] = function ($event) { return (_ctx.$emit('sms', _ctx.nurse)); })
                    }, __spreadArray([], (_cache[30] || (_cache[30] = [
                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-comment" }, null, -1),
                        (0, vue_2.createTextVNode)(" Text ", -1)
                    ])), true)),
                    (0, vue_2.createElementVNode)("button", {
                        type: "button",
                        class: "quick-action call-action",
                        onClick: _cache[5] || (_cache[5] = function ($event) { return (_ctx.$emit('call', _ctx.nurse)); })
                    }, __spreadArray([], (_cache[31] || (_cache[31] = [
                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-comment bi-phone" }, null, -1),
                        (0, vue_2.createTextVNode)(" Call ", -1)
                    ])), true))
                ])
            ]));
        };
    }
});
